import { SingleDataLoader } from 'components/Atoms/SingleDataLoader'
import { UserOverviewCSS } from './UserOverviewCSS.styled'
import { currencyFormatter } from 'utils'
import { useUser } from 'hooks/user/useUser'
import { isAddressesEqual } from 'utils/wallet/addresses'
import { useMemo } from 'react'

export const UserOverview = ({ isPending, userPublicData, isForMe }) => {
  const { overviewData } = userPublicData
  const { account: loggedAccount } = useUser('wallet')

  return (
    <UserOverviewCSS>
      <div className='content column'>
        <div className='grid-content'>
          {/* <!-- ROW --> */}
          <label className='title'>Total Bids</label>
          <label className='value'>
            <SingleDataLoader
              loading={isPending}
              data={overviewData?.totalBids}
            />
          </label>
          {/* <!-- ROW --> */}
          <label className='title'>Total amount bid</label>
          <label className='value'>
            <SingleDataLoader
              loading={isPending}
              data={currencyFormatter(overviewData?.totalAmountBid)}
            />
          </label>
          {/* <!-- ROW --> */}
          {/* {isForMe && ( */}
          {false && (
            <>
              <label className='title'>Total profit</label>
              <label className='value'>
                <SingleDataLoader
                  loading={isPending}
                  data={currencyFormatter(overviewData?.totalProfit)}
                />
              </label>
            </>
          )}
          {/* <!-- ROW --> */}
          {/* {isForMe && ( */}
          {false && (
            <>
              <label className='title'>Total ROI</label>
              <label className='value'>
                <SingleDataLoader
                  loading={isPending}
                  data={currencyFormatter(overviewData?.totalRoi)}
                />
              </label>
            </>
          )}
          {/* <!-- ROW --> */}
          <label className='title'>Largest & most profitable single bid</label>
          <label className='value'>
            <SingleDataLoader
              loading={isPending}
              data={currencyFormatter(overviewData?.largestBid)}
            />
          </label>
        </div>
      </div>
    </UserOverviewCSS>
  )
}
